import React, { Component } from 'react';
import { useState, useEffect } from "react";
import logo from './logo.svg';
import './App.css';
import './spapp.css';
import './common.css';

import Select from 'react-select';
import Header from './Header';

import Home from './Home';
import Signupandroid from './Signupandroid';
import Signup from './Signup';

import * as ReactDOM from 'react-dom';
import  Cthmchat from './Chat';
import {clearmain,clearprofile} from './clearmem';
import waits from './imgs/wait.gif';
import {Exituser} from './userdefaultdata';
import Configdata from './Defaultdata';
import Usersession from './Usersession';

function App() {
        let superuserid = 0;
	useEffect(() => {
		const link = document.querySelector('link[rel="icon"]');

		if (link) {
			link.setAttribute('href', 'favicon-devp.ico');
		
		}
	      //showchat();
        const handler = (event:any) => {
                   
                                    //    const apurl =Configdata.srvurl + '/removeatclose';
                                        const apurl =Configdata.srvurl + '/removechatusrs';

         				const userid = Usersession.getUserId();

                     // const data = JSON.stringify({ event: 'tab_closed', time: Date.now() });
                    const data = JSON.stringify({ uid: userid });

  			navigator.sendBeacon(apurl, new Blob([data], { type: 'application/json' }));
                      //  const data = JSON.stringify({ event: 'tab_closed', time: Date.now() });
  			//navigator.sendBeacon('/api/log', data);
        };
       window.addEventListener('beforeunload', handler);
          return () => {

      // Cleanup the event listener when the component unmounts
      window.removeEventListener('beforeunload', handler);
    };
   }, []);

function getsuperuserid(){
const suid = localStorage.getItem('Superuserid');
return suid;
}
function showchat(){
	var maindiv = document.getElementById('container') as HTMLElement;
	
	//var dv = Cthmchat();
    	//ReactDOM.render(dv,maindiv);
       

}

  return (
	
  
       <div style={{ width: '99.8%', height: '99%' }}>
		  
		 <div className="headermaindiv" style={{display:'none'}}>
			<Header /> 
		</div>
		<div id="container" className="per100">
			<Home />
		</div>
		<div id="profilediv" className="sidebar-profile" style={{display:'none'}}>
		
		</div>
		<div id="customemsgdiv" className="custom-msgcht" style={{display:'none'}}>
			
		</div>
		
		 <div id="delayprocess" style={{display:'none'}} className="per100">
		 <img src={waits} style={{height:'60vh',width:'60vw',position:'fixed',top:'20vh',left:'20vw'}} />

   	</div>	
          
       </div>

      );
}

export default App;
